import {ADD_ARTICLE} from '../const/action-types';
import companyReducer from './company';
import { combineReducers } from 'redux';

const allReducers = combineReducers({
    companyReducer: companyReducer
})

export default allReducers;